import type { ReactElement } from 'react';
import { checkTalkLine } from '../../../../../shared/check-handoff.js';
import { GamesTalkHandoff } from './GamesTalkHandoff';

/**
 * Where a self-check page (/check/<slug>, 2026-10-27) hands a person to Ember.
 * The link carries only which check and the ticked answers as digits; the first
 * line is written from them (shared/check-handoff.js), the same line the page
 * showed before the person tapped Send. The page itself is the games' shared
 * one (GamesTalkHandoff): the consent boxes for a signed-out browser, then the
 * line goes out as the person's first message.
 */
export function CheckTalkHandoff({ search }: { search: URLSearchParams }): ReactElement {
  return (
    <GamesTalkHandoff
      line={checkTalkLine(search.get('check'), search.get('a'))}
      discovery="check"
    />
  );
}
